export default __webpack_public_path__ + "static/media/11-color.55c4a9e4.svg";